module.exports = __webpack_public_path__ + "img/icon05.2fdde9e1.png";